import { render, staticRenderFns } from "./vehicles_management.vue?vue&type=template&id=37827935&scoped=true"
import script from "./vehicles_management.vue?vue&type=script&lang=js"
export * from "./vehicles_management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37827935",
  null
  
)

export default component.exports